import apiV1 from "../../services/apiV1";

// Ad accounts are linked per project.
export const listAdAccounts = (projectId) =>
  apiV1.get("/ad-accounts", { params: { projectId } }).then((r) => r.data.data);

// Returns the provider consent URL to navigate to.
export const connectAdAccount = (provider, returnTo, projectId) =>
  apiV1.post("/ad-accounts/connect", { provider, returnTo, projectId }).then((r) => r.data.data.url);

// Pick which ad account a connection should use.
export const selectAdAccount = (id, accountId) =>
  apiV1.put(`/ad-accounts/${id}/select`, { accountId }).then((r) => r.data.data);

export const deleteAdAccount = (id) =>
  apiV1.delete(`/ad-accounts/${id}`).then((r) => r.data);
